module.exports = __webpack_public_path__ + "static/media/instrument3.23539d26.jpg";